import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
    selector: 'app-toolbar-button',
    templateUrl: './toolbar-button.component.html',
    styleUrls: ['./toolbar-button.component.scss'],
    standalone: false,
})
export class ToolbarButtonComponent implements OnInit, OnDestroy {
    @Input() set isActive(value: boolean) {
        this.active = value;
    }
    @Input() icon: string;
    @Input() setDefault$: BehaviorSubject<void>;
    @Input() tooltip: string;
    @Input() disabled: boolean;
    @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

    active: boolean;
    statuses = {
        DEFAULT: 'default',
        FOCUS: 'focus',
        ACTIVE: 'active',
    };
    currentStatus: string;

    private subscriptions: Subscription[] = [];

    constructor() {
        this.currentStatus = this.statuses.DEFAULT;
    }

    ngOnInit() {
        this.subscriptions.push(
            this.setDefault$.subscribe(() => {
                this.currentStatus = this.statuses.DEFAULT;
            })
        );
    }

    onButtonClick() {
        this.buttonClick.emit();
        this.currentStatus = this.statuses.FOCUS;
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
